import { validateUserLogin, validateForgotPassword, validateResetPassword, validateProfile, validateChangePassword, validateUserRegistration } from './user';
import { validatePrivateNotes, validateCaseAction } from './caseForms';
import { validateCheckout } from './checkout';

export const minLength = length => value => (value && value.length < length)
  ? `Too short.`
  : undefined;

export const numericCharacter = value => (value && !/[0-9]/i.test(value))
  ? 'Must contains at least 1 number'
  : undefined;

export const alphaCharacter = value => (value && !/[a-z]/i.test(value))
  ? 'Must contains at least 1 letter'
  : undefined;

export const specialCharacter = specialCharacters => value => (value && !specialCharacters.split('').find(sc => value.includes(sc)))
  ? 'Must contain at least 1 special character'
  : undefined;

export const passwordValidation = ({ specialCharacters, minPasswordLength}) => password => password ? (
  minLength(minPasswordLength)(password) || 
  numericCharacter(password) ||
  alphaCharacter(password) ||
  specialCharacter(specialCharacters)(password)
) : undefined;

export {
  validateUserLogin,
  validateForgotPassword,
  validateResetPassword,
  validateProfile,
  validateChangePassword,
  validatePrivateNotes,
  validateUserRegistration,
  validateCaseAction,
  validateCheckout
};
